<template>
  <div id="capitalist-app" class="main-logged-layout">
    <Toast position="top-right"></Toast>
    <cap-header />
    <cap-main-logged></cap-main-logged>
    <cap-footer />
  </div>
</template>

<style lang="less">
</style>

<script>
import CapHeader from '@/views/layouts/CapHeader';
import CapFooter from '@/views/layouts/CapFooter';
import CapMainLogged from '@/views/layouts/CapMainLogged';
import { ApplicationLocale } from '@/models/ApplicationLocale';

import Toast from 'primevue/toast';

export default {
  name: 'LoggedContainer',
  created() {
    this.$i18n.locale = ApplicationLocale.getInstance().locale;
  },
  components: {
    'cap-header': CapHeader,
    'cap-footer': CapFooter,
    'cap-main-logged': CapMainLogged,
    Toast
  },
};
</script>
